<template>
  <div class="page-default">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#f6861f" />
    <HeadBar />
    <Navbar />

    <slot />

    <FootBar />
    <LoginNeedModal />

    <login-need-modal ref="loginNeedModal" />
    <!-- <Popup-PKS ref="autoModal" /> -->
  </div>
</template>

<script>
import HeadBar from "@/components/guest/HeadBar.vue";
import Navbar from "@/components/guest/Navbar.vue";
import FootBar from "@/components/guest/FootBar.vue";
import LoginNeedModal from "@/components/modals/LoginNeedModal.vue";
// import PopupPKS from "@/components/modals/PopupPKS.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";

export default {
  components: {
    HeadBar,
    Navbar,
    FootBar,
    Loading,
    LoginNeedModal,
    // PopupPKS
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
      isPopuplogin: "isPopuplogin"
    })
  },
  mounted() {
    // this.$refs["autoModal"].show();
    if (this.isPopuplogin) {
      this.$refs.loginNeedModal.show();
    }
  },
  watch: {
    // $route(to, from) {
    //   if (to.path === "/") {
    //     this.$refs["autoModal"].show();
    //   }
    // },
    isPopuplogin() {
      if (this.isPopuplogin) {
        this.$refs.loginNeedModal.show();
      }
    }
  }
};
</script>

